// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___1UluR","open":"open___1loUq","header":"header___1Z0ao","content":"content___3sbpv","formCard":"formCard___3S9He","title":"title___qFons"};